export type TProduct = {
    id: string
    title: string
    price: string
}

export const deleteUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/catalog/`
export const getUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/product/get/filtred/pages`
export const updateUrl = `${process.env.NEXT_PUBLIC_API_ENDPOINT}/catalog/`

const token_cookie_name = "token_jwt"

export const setJwtToken = (headers: any) => {
    try {
        const cookie: string = document.cookie
        if (cookie) {
            const jwtCookie = cookie
                .split("; ")
                .find((row) => row.startsWith(`${token_cookie_name}=`))
                ?.split(`${token_cookie_name}=`)[1]
            headers.set("Authorization", `Bearer ${jwtCookie}`)
        }
        return headers
    } catch {
        return headers
    }
}
